export default {"src":"/_next/static/media/amazon_prime.41999e4b.svg","height":41,"width":40};